import React from "react";

// Hand-drawn SVG scribbles painted in pure ink black.
// Absolutely positioned by parent via className.

export const Star = ({ className = "", size = 40 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1A1A1A"
    strokeWidth="1.4"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M12 2c.4 4.2 2.1 6.9 6 8.4-3.9 1.5-5.6 4.2-6 8.4-.4-4.2-2.1-6.9-6-8.4 3.9-1.5 5.6-4.2 6-8.4z" />
  </svg>
);

export const Arrow = ({ className = "", size = 60 }) => (
  <svg
    className={className}
    width={size}
    height={size * 0.6}
    viewBox="0 0 100 60"
    fill="none"
    stroke="#1A1A1A"
    strokeWidth="1.6"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M4 30c22-14 46-16 88-4" />
    <path d="M78 12c6 6 10 10 14 14-6 2-11 5-15 11" />
  </svg>
);

export const Squiggle = ({ className = "", width = 120 }) => (
  <svg
    className={className}
    width={width}
    height="16"
    viewBox="0 0 120 16"
    fill="none"
    stroke="#C95A3B"
    strokeWidth="2"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M2 8c8-6 16 6 24 0s16-6 24 0 16 6 24 0 16-6 24 0 16 6 20 0" />
  </svg>
);

export const Spiral = ({ className = "", size = 50 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 50 50"
    fill="none"
    stroke="#1A1A1A"
    strokeWidth="1.4"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M25 25c0-4 6-4 6 0s-8 6-8-1 11-8 12 1-11 12-15 0 16-15 15 6" />
  </svg>
);

export const Underline = ({ className = "", width = 200 }) => (
  <svg
    className={className}
    width={width}
    height="14"
    viewBox="0 0 200 14"
    fill="none"
    stroke="#C95A3B"
    strokeWidth="3"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M3 8c40-5 120-6 194 1" />
  </svg>
);

export const Sun = ({ className = "", size = 70 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 70 70"
    fill="none"
    stroke="#D4A017"
    strokeWidth="1.6"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <circle cx="35" cy="35" r="12" />
    <path d="M35 6v9M35 55v9M6 35h9M55 35h9M14 14l6 6M50 50l6 6M56 14l-6 6M20 50l-6 6" />
  </svg>
);
